import React from 'react';

/**
 * Small signed-in-user chip shown at the bottom of the sidebar.
 * Consistent in both AppShell (owner/barber view) and AdminShell.
 */
const ROLE_LABELS = {
  master_admin: 'Master admin',
  shop_admin:   'Shop admin',
  barber:       'Barber',
  customer:     'Customer',
};
const ROLE_CLASSES = {
  master_admin: 'master',
  shop_admin:   'shop',
  barber:       'barber',
  customer:     '',
};

const initials = (s) =>
  (s || '').split(/\s+/).filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';

export const UserChip = ({ profile, email }) => {
  const display = profile?.full_name || profile?.name || (email ? email.split('@')[0] : 'Signed in');
  const role = profile?.role || 'customer';
  return (
    <div className="userchip" data-testid="user-chip">
      <div className="avatar" aria-hidden="true">{initials(display)}</div>
      <div className="who">
        <b data-testid="user-chip-name">{display}</b>
        {email && <small data-testid="user-chip-email">{email}</small>}
        <span className={`role-pill ${ROLE_CLASSES[role] || ''}`} data-testid="user-chip-role">
          {ROLE_LABELS[role] || role}
        </span>
      </div>
    </div>
  );
};

export default UserChip;
